var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-0",attrs:{"flat":"","height":"100%","color":_vm.$route.meta.greyBg ? 'grey lighten-4' : ''}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }